<template>
  <div class="terms">
    <header class="terms__header">
      <h2>Privacy Policy Explanation:</h2>

      <div class="img" @click="$emit('close')">
        <img :src="mediaBaseUrl + 'close.svg'" alt="close">
      </div>
    </header>

    <privacy-policy-text />
  </div>
</template>

<script>
export default {
  name: "PrivacyModal",

  inject: ["mediaBaseUrl"],
}
</script>

<style lang="sass">
.terms .terms__header h2
  margin-bottom: 0
</style>
